<template>
  <va-page-not-found class="va-page-not-found-simple">
    <s1-icon slot="image" tamanho="150x150"/>
  </va-page-not-found>
</template>

<script>
import S1Icon from '../../../iconset/S1Icon'
import VaPageNotFound from './VaPageNotFound'

export default {
  name: 'vuestic-page-not-found-simple',
  components: {
    VaPageNotFound,
    S1Icon,
  },
}
</script>

<style lang="scss">
.va-page-not-found-simple {
  .va-icon-vuestic {
    width: 19rem;
    height: 2rem;
    max-width: 100%;
    margin-bottom: 13%;
  }
}
</style>
